import { render, staticRenderFns } from "./VideoScroll.vue?vue&type=template&id=37556b8b&"
import script from "./VideoScroll.vue?vue&type=script&lang=js&"
export * from "./VideoScroll.vue?vue&type=script&lang=js&"
import style0 from "./VideoScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports